import { Link } from "react-router";
import {
  Contact,
  Megaphone,
  BarChart3,
  LineChart,
  Receipt,
  Ticket as TicketIcon,
  TrendingUp,
  Users,
  Target,
} from "lucide-react";
import { isRouteEnabled, paths } from "@shared-core/routing/routes";

// The scattered sales-relevant corners of CIS the sales team named directly
// (product brief §5, point 2) — reachable in one click from the dashboard
// instead of hunted for. Kept short deliberately: a long quicklink list
// reproduces the exact scatter problem this is meant to fix (brief §10).
//
// "All tickets" stays last deliberately (Lauren, 2026-09-22) — it's the
// odds-and-ends catch-all next to the more specific sales surfaces above it.
const QUICKLINKS_BEFORE_AWAITING_INVOICE = [
  { to: paths.customers(), label: "Customers", icon: Users },
  { to: paths.contacts(), label: "Contacts", icon: Contact },
  { to: paths.marketingPeople(), label: "Marketing contacts", icon: Megaphone },
  { to: paths.leads(), label: "Leads", icon: Target },
  { to: paths.myPipeline(), label: "Pipeline", icon: TrendingUp },
];

// The rep's own jobs waiting on an invoice, all dates — the same list the
// Sales home tile opens.
const AWAITING_INVOICE_QUICKLINK = {
  to: paths.jobs({ bucket: "awaiting_invoice", mine: true, range: "all" }),
  label: "Awaiting invoice",
  icon: Receipt,
};

const QUICKLINKS_AFTER_AWAITING_INVOICE = [
  { to: paths.insights(), label: "Insights", icon: BarChart3 },
  { to: paths.repFigures(), label: "Rep vs company figures", icon: LineChart },
  { to: paths.tickets(), label: "All tickets", icon: TicketIcon },
];

export function QuicklinksRow() {
  // Checked per render, not at module load: features arrive from /me after
  // the bundle loads, so a module-level check would always read "off".
  const quicklinks = [
    ...QUICKLINKS_BEFORE_AWAITING_INVOICE,
    ...(isRouteEnabled("jobs") ? [AWAITING_INVOICE_QUICKLINK] : []),
    ...QUICKLINKS_AFTER_AWAITING_INVOICE,
  ];
  return (
    <div>
      <h2 className="text-lg mb-2">Quicklinks — where would you like to go?</h2>
      <div className="flex items-center gap-2 flex-wrap">
        {quicklinks.map(({ to, label, icon: Icon }) => (
          <Link
            key={to}
            to={to}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm border border-border bg-surface hover:bg-surface-hover hover:border-primary/40 transition-colors"
          >
            <Icon className="size-3.5 text-primary" />
            {label}
          </Link>
        ))}
      </div>
    </div>
  );
}
